/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pit-page-footer__content[_ngcontent-%COMP%]{text-align:center;background:rgba(0,0,0,.07);height:24px;width:100%}\n/*# sourceMappingURL=pit-page-footer.component.css.map*/"];
export { styles as styles };
